import { useMemo } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  deploymentErrorSelector,
  currentDeploymentServicesSelector
} from "Reducers/environment/deployment";
import { useLoadDeploymentsCurrent } from "Reducers/environment/deployment/hooks";
import { useAppSelector } from "Store/hooks";

type ParamType = {
  environmentId: string;
  organizationId: string;
  projectId: string;
};

export const useServiceList = () => {
  const { environmentId, organizationId, projectId } =
    useDecodedParams<ParamType>();

  const currentService = useSelectorWithUrlParams(
    currentDeploymentServicesSelector
  );

  const error = useAppSelector(state =>
    deploymentErrorSelector(state, { environmentId, projectId, organizationId })
  );

  const serviceList = useMemo(
    () => ({
      app: Object.values(currentService?.webapps || {}),
      service: Object.values(currentService?.services || {}),
      worker: Object.values(currentService?.workers || {})
    }),
    [currentService]
  );

  useLoadDeploymentsCurrent(
    {
      organizationId,
      projectId,
      environmentId
    },
    !currentService
  );

  return { serviceList, error };
};
